<div [class]="theme$ | async">
  <button class="mat-dialog-close" (click)="postponeDialog()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <!-- Dialog: Header -->
  <div class="mat-dialog-header">
    <h2>Refresh Orders</h2>
  </div>

  <!-- Dialog: Content -->
  <div class="mat-dialog-body">
    <!--    <p>It has been {{data.timeIntevalSeconds * 60}} minutes since your last refresh.</p>-->
    <p>
      Your page will automatically refresh in <span>{{ timeLeft }}</span>
    </p>
  </div>

  <!-- Dialog: Footer/Actions -->
  <div class="mat-dialog-footer" mat-dialog-actions>
    <div class="btn-group">
      <button cdkFocusInitial (click)="refreshList()" class="btn btn-primary">
        Refresh Now
      </button>
      <button cdkFocusInitial (click)="postponeDialog()" class="btn btn-secondary">
        Postpone
      </button>
    </div>
  </div>
</div>
